import dividerComponent from './dividerComponent';
import extendComponents from './extendComponents';
import gridComponent from './gridComponent';
import headingComponent from './headingComponent';
import imageBoxComponent from './imageBoxComponent';
import linkBoxComponent from './linkBoxComponent';
import onBeforeStyle from "./parseStyles";
import sectionComponent from './sectionComponent';
import iconComponent from './iconComponent';
import {getAppEditorStore} from "../../../store/appEditorStore";
import {findOneDepthParent} from "../../index";

const basicCategory = 'Basic';

export default function pluginWeb(editor) {
    // const store = getStore();
    // @ts-ignore TODO TS gjs
    editor.Css.getConfig().onBeforeStyle = onBeforeStyle;

    // TODO remove
    editor.Components.addType('trait-check', {
        model: {
            defaults: {
                traits: [
                    'id',
                    'title',
                    {
                        type: 'select',
                        name: 'select-type',
                        options: [
                            {id: 'value1', label: 'Value 1'},
                            {id: 'value2', label: 'Value 2'},
                            {id: 'value3', label: 'Value 3'},
                        ]
                    },
                    {
                        type: 'number',
                        name: 'number-type',
                        // @ts-ignore TODO ts
                        units: ['px'],
                    },
                    {
                        type: 'checkbox',
                        name: 'checkbox-type',
                    },
                    {
                        type: 'color',
                        name: 'color-type',
                    },
                    {
                        type: 'button',
                        name: 'button-type',
                        label: 'Delete',
                        command: 'core:component-delete',
                    },
                ]
            }
        }
    });

    const basicBlocksProps = {category: basicCategory, select: true, activate: true};

    const originalGetModelToStyle = editor.StyleManager.getModelToStyle;

    editor.StyleManager.getModelToStyle = function (el) {
        const higherComponent = findOneDepthParent(el);
        let cssRule = getAppEditorStore().getComponentCssRuleWithDevice(el, editor.getDevice());
        if (!cssRule) {
            cssRule = originalGetModelToStyle.call(this, el);
            if (higherComponent) {
                cssRule.attributes['component'] = getAppEditorStore().getComponentSelectorString(higherComponent);
            }
            return cssRule;
        } else {
            const modelSelector = el.getSelectorsString()
            const wrapper = editor.DomComponents.getWrapper();
            const sameModels = wrapper.find(modelSelector);
            if (sameModels.length > 1 || ((editor.getDevice() === 'Mobile' && cssRule.attributes.mediaText.length === 0) || (editor.getDevice() === 'Desktop' && cssRule.attributes.mediaText.length > 0))) {
                const newCssRule = cssRule.clone();
                newCssRule.attributes.previousCssRule = cssRule.getSelectorsString();
                if (higherComponent) {
                    newCssRule.attributes['component'] = getAppEditorStore().getComponentSelectorString(higherComponent);
                }
                if (editor.getDevice() === 'Mobile') {
                    newCssRule.attributes.mediaText = 'screen and (max-width: 590px)'
                }
                return newCssRule;
            } else {
                if (editor.getDevice() === 'Mobile') {
                    cssRule.attributes.mediaText = 'screen and (max-width: 590px)'
                }
                return cssRule;
            }
        }
    };

    extendComponents(editor, {});
    gridComponent(editor, {block: basicBlocksProps});
    headingComponent(editor, {block: basicBlocksProps});
    sectionComponent(editor, {block: basicBlocksProps});
    dividerComponent(editor, {block: basicBlocksProps});
    imageBoxComponent(editor, {block: basicBlocksProps});
    linkBoxComponent(editor, {block: basicBlocksProps});
    iconComponent(editor, {block: basicBlocksProps});
}